import React, { useState } from 'react';
import {
    useStripe,
} from "@stripe/react-stripe-js";
import ModalError from "components/UI/Modal/ModalError";
import './stripeCard.css';

const PaymentIntentBancontact = (props) => {

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [name, setName] = useState('');
    const stripe = useStripe();
    const clientSecretBancontact = props.clientSecretBancontact;

    const closeModalError = () => {
        setIsOpenModal(false)
    }

    const onChangeName = (event) => {
        
        setDisabled(event.target.value.length < 1 ? true : false);

        if(event.target.value.length >= 99){
            setError(`Owner name is too long, please enter a name with less than 100 characters`);
            document.getElementById("card-element").focus();
            setIsOpenModal(true)
            return;
        }
        
        setName(event.target.value);

        setError(event.error ? event.error.message : "")   
    }

    const handleSubmitStripe = async (event) => {
        event.preventDefault();

        if(document.getElementById("card-element").value.length < 1){
            setError(`Please enter your name`);
            document.getElementById("card-element").focus();
            setIsOpenModal(true)
            return;
        }
        
        setProcessing(true);

        const clientSecret = clientSecretBancontact;

        const payload = await stripe.confirmBancontactPayment(clientSecret, {
            payment_method: {
                billing_details: {
                    name: name,
                  },
            },
            return_url: `${window.location.origin}/Menu/checkout`,
        });

        if (payload.error) {
            console.log("error stripe", payload.error.message)
            setError(`Payment failed ${payload.error.message}`);
            setProcessing(false);
            setIsOpenModal(true)
        } else {
            console.log("Stripe status", payload.status)
            setError(null);
            setProcessing(false);
            setSucceeded(true);
        }
    }

    return (

        <form className="payment-form" onSubmit={handleSubmitStripe} ref={props.formReference}>

            <label className="payment-details">Payment Bancontact Details</label>
            <div className="stripe-card">

                <label>Name</label>
                <input type="text" id="card-element" value={name} onChange={onChangeName} maxlength="99"/>

                <button className="buttonStripe"
                    disabled={processing || disabled || succeeded}
                    id="submit"
                    type="submit"
                >
                    <span id="button-text">
                        {processing ? (<div className="spinner" id="spinner"></div>) : ("PAY NOW")}
                    </span>
                </button>

                <ModalError
                    style={{ zIndex: "99999", position: "absolute", margin: "5% 26%" }}
                    showModal={isOpenModal}
                    closeModal={closeModalError}
                    errorMessage={error}
                />
            </div>
        </form>
    )
}

export default PaymentIntentBancontact;


// WEBPACK FOOTER //
// ./src/containers/Checkout/Stripe/stripeBancontact.js